module.exports = __webpack_public_path__ + "img/4-3-1-5-1-preview-ufi-global-e.2fece662.jpg";